import React, { PureComponent } from 'react';

import ModalContainer from '../../../../components/shared/modal/ModalContainer';
import { PrimaryButton, StyledRow } from '../../../../components/shared/sharedStyles.styles';
import { Container, SpanTitle, GrayText } from './fieldModal/formModalFields.styled';

class ReinclusionModal extends PureComponent {

  renderFooter = () => (
    <StyledRow padding='0 3em' justify="space-around">
      <PrimaryButton data-testid="go-back-button" onClick={this.props.onClose} >Voltar</PrimaryButton>
      <PrimaryButton data-testid="send-data-button" onClick={this.props.reinclude}>Avançar</PrimaryButton>
    </StyledRow>
  )

  renderHeader = () => (
    <SpanTitle customstyle="margin: auto;">
      ATENÇÃO
    </SpanTitle>
  )

  render() {
    return (
      <ModalContainer
        isOpen={this.props.isOpen}
        size="md"
        onClose={this.props.onClose}
        footer={this.renderFooter()}
        header={this.renderHeader()}
      >

        <Container customstyle="text-align: center; margin: 20px auto;">
          <GrayText>
            Já existe na sua conta um pretendente com este mesmo documento (CPF ou CNPJ) consultado nos últimos 30 dias. Deseja <b>AVANÇAR</b> com uma nova consulta <b>MESMO ASSIM</b>? Esta nova consulta será cobrada.
          </GrayText>
        </Container>

      </ModalContainer>
    );
  }
}

export default ReinclusionModal;
